export enum ModalVisualMode {
  Plain = 'plain',
  Happy = 'happy',
  Check = 'check',
  ExtraCautious = 'extra-cautious',
  Encouragement = 'encouragement',
  ThinkTwice = 'think-twice',
  Think = 'think',
  TechnicalError = 'technical-error',
  NoAccess = 'no-access',
  Sympathy = 'sympathy',
}
